import createPersistedState from 'vuex-persistedstate'

export default ({ store }) => {
  try {
    createPersistedState({
      key: 'beisheim',
      paths: ['cookies']
    })(store)
  } catch (e) {
    // nothing we can do about
  }
}
